import React from "react";
import {
  FormattedMessage,
  FormattedNumber,
  WrappedComponentProps,
  injectIntl,
} from "react-intl";

import Input from "./Input";
import styles from "./Distance.module.css";
import PropertyWithTitle from "./PropertyWithTitle";

interface DistanceProps {
  className?: string;
  text?: string;
  onChange?: (value: number) => any;
  valueInMetres: number;
}

interface OriginalDistanceProps {
  text?: string;
  valueInMetres: number;
}

interface DistanceWithTitleProps extends DistanceProps {
  id?: string;
  hintTitle?: string;
  hintValueInMetres?: number;
  title?: string;
}

// interface EditableDistanceProps {
//   id?: string
//   className?: string
//   onChange: (value: number) => any
//   valueInMetres: number
// }

export function toMetres(valueInKm: string): number {
  return Number(valueInKm.replace(",", ".")) * 1000;
}
export function toKm(valueInMetres: number): number {
  return Math.round(valueInMetres / 1000);
}

export function OriginalDistance(props: OriginalDistanceProps) {
  if (!props.text) {
    return null;
  }
  return <Distance text={props.text} valueInMetres={props.valueInMetres} />;
}

export const EditableDistance = injectIntl(
  ({
    id = "distance",
    intl,
    onChange,
    hintTitle,
    hintValueInMetres,
    title = "shared.distance",
    valueInMetres,
  }: DistanceWithTitleProps & WrappedComponentProps) => {
    if (!onChange) {
      throw new Error("onChange should be defined");
    }
    const description =
      hintTitle && typeof hintValueInMetres === "number"
        ? intl.formatMessage(
            { id: hintTitle },
            {
              distance: toKm(hintValueInMetres),
            },
          )
        : "";
    return (
      <Input
        id={id}
        label={intl.formatMessage({ id: title })}
        type="number"
        onChange={(e) => onChange(toMetres(e.target.value))}
        defaultValue={String(toKm(valueInMetres))}
        description={description}
      />
    );
  },
);

export function DistanceWithTitle(props: DistanceWithTitleProps) {
  const {
    className,
    onChange,
    hintTitle,
    hintValueInMetres,
    text,
    title = "shared.distance",
    valueInMetres,
  } = props;
  if (valueInMetres === 0 && !onChange) {
    return null;
  }
  if (onChange) {
    return <EditableDistance {...props} />;
  }
  return (
    <PropertyWithTitle title={title}>
      <Distance {...{ className, text, valueInMetres }} />
      {hintTitle && typeof hintValueInMetres === "number" && (
        <OriginalDistance valueInMetres={hintValueInMetres} text={hintTitle} />
      )}
    </PropertyWithTitle>
  );
}

export default function Distance({
  className = styles.root,
  text = "distance",
  valueInMetres,
}: DistanceProps) {
  if (valueInMetres === 0) {
    return null;
  }
  return (
    <div className={className}>
      <FormattedNumber value={toKm(valueInMetres)}>
        {(distance) => (
          <FormattedMessage
            values={{
              distance,
            }}
            id={text}
          />
        )}
      </FormattedNumber>
    </div>
  );
}
